// extracted by mini-css-extract-plugin
export default {"container":"TagWithRemove_container__d9Klf","close":"TagWithRemove_close__BAar8"};